import { render, staticRenderFns } from "./NoteHistoryLog.vue?vue&type=template&id=eb56cc98&scoped=true"
import script from "./NoteHistoryLog.vue?vue&type=script&lang=ts"
export * from "./NoteHistoryLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb56cc98",
  null
  
)

export default component.exports